<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepSummary.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepSummary.BODY')"></p>
    <v-container grid-list-xs>
      <v-card>
        <v-toolbar>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" @click.native="$emit('back')">{{ $t('forms.BACK') }}</v-btn>
          <v-btn class="blue--text darken-1" @click.native="$emit('continue')">{{ $t('forms.FINISH') }}</v-btn></v-toolbar>
        <!--<v-card-title class="headline">{{ $t('questionnaire.completed.TITLE') }}</v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <evaloe-results :questionnaire="this.questionnaire" :questionnaireItems="this.questionnaireItems"></evaloe-results>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<style>
  .container.grid-list-xs .layout .flex {
    padding: 1px;
  }
</style>
<script>
  import EvaloeResults from '../questionnaires/EvaloeResults'
  export default {
    name: 'tutorial-step-summary',
    components: {EvaloeResults},
    data () {
      return {
        questionnaireItems: [
          { questionnaireId: 1, itemId: 1, itemOrder: 1, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 2, itemOrder: 2, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 3, itemOrder: 3, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 4, itemOrder: 4, answered: true, answer: 3 },
          { questionnaireId: 1, itemId: 5, itemOrder: 5, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 6, itemOrder: 6, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 7, itemOrder: 7, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 8, itemOrder: 8, answered: true, answer: 3 },
          { questionnaireId: 1, itemId: 9, itemOrder: 9, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 10, itemOrder: 10, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 11, itemOrder: 11, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 12, itemOrder: 12, answered: true, answer: 3 },
          { questionnaireId: 1, itemId: 13, itemOrder: 13, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 14, itemOrder: 14, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 15, itemOrder: 15, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 16, itemOrder: 16, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 17, itemOrder: 17, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 18, itemOrder: 18, answered: true, answer: 3 },
          { questionnaireId: 1, itemId: 19, itemOrder: 19, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 20, itemOrder: 20, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 21, itemOrder: 21, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 22, itemOrder: 22, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 23, itemOrder: 23, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 24, itemOrder: 24, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 25, itemOrder: 25, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 26, itemOrder: 26, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 27, itemOrder: 27, answered: true, answer: 1 },
          { questionnaireId: 1, itemId: 28, itemOrder: 28, answered: true, answer: 2 },
          { questionnaireId: 1, itemId: 29, itemOrder: 29, answered: true, answer: 3 },
          { questionnaireId: 1, itemId: 30, itemOrder: 30, answered: true, answer: 3 }
        ],
        questionnaire: {
          version: this.$auth.user().version
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStepSummary.vue